/**
 * Google OAuth entry point.
 *
 * A full-page redirect rather than an axios call, so it bypasses the shared instance
 * (and therefore the auth and URL-masking interceptors) entirely. That is unavoidable
 * for an OAuth bounce, but it is exactly why this lives in one place: the redirect used
 * to be duplicated verbatim in LoginNew and Register, so threading anything new through
 * it -- an invite token, say -- meant remembering to edit both.
 */

/**
 * Start the Google OAuth flow.
 *
 * @param {string} [inviteToken] Organization invite token. When present the backend
 *   stashes its HASH in the auth session for the duration of the round trip and, on
 *   return, places the new account in the inviting org with the invited role instead of
 *   applying the usual email-domain rules. Ignored if it does not match the address the
 *   user actually authenticates with.
 */
export const startGoogleLogin = (inviteToken) => {
  const backendUrl = process.env.REACT_APP_API_BASE_URL || '/api';
  const query = inviteToken ? `?invite=${encodeURIComponent(inviteToken)}` : '';
  window.location.href = `${backendUrl}/auth/google/login${query}`;
};

export default startGoogleLogin;
